module.exports = __webpack_public_path__ + "img/20180815_145911_034.1f304845.jpg";